var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch-button switch-button-yesno"},[_c('input',{ref:"switchInput",attrs:{"type":"checkbox","id":_vm.id},domProps:{"checked":_vm.on},on:{"change":_vm.onChange}}),_vm._v(" "),_c('span',[_c('label',{attrs:{"for":_vm.id}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06dd7230","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SwitchButton/switch-button.vue
// module id = null
// module chunks = 